import Clarity from '@microsoft/clarity';

export function ClarityProvider({ children, environment }) {
    if (environment === "production") {
        Clarity.init("u0vo1gqaf1");
    }

    return children;
}
